import axios from 'axios'

export const state = {
  all: []
}

export const getters = {
  allEpsProviders: state => state.all
}

export const actions = {
  getAllEpsProviders ({ commit }) {
    axios.get('epsProviders').then(promise => {
      commit('RECEIVE_EPS_PROVIDERS', promise.data.results)
    })
  }
}
export const mutations = {
  RECEIVE_EPS_PROVIDERS (state, epsProviders) {
    state.all = epsProviders
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
